<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.soru_listeleri"  url="CreateProject" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>

<div class="content_card_content">


<!--
<ContentTable :data="data" :columns="columns" routename="Questionlist" deleteobjectname="questionlist" @dataDeleted="getData"></ContentTable>
-->
<SortableTable :data="data" :columns="columns" routename="Questionlist" deleteobjectname="questionlist" @dataDeleted="getData"></SortableTable>

</div>





</div>







</div>
</template>

<script>
export default {

  name: 'Projects',

  data () {
    return {
    	data:[],
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
      },
       {
        type:"text",
        field:"brand_name",
        header:"marka",
        hide_on_mobile:true,
      },
      {
        type:"text",
        field:"project_name",
        header:"proje",
        hide_on_mobile:true,
      },       
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:true,
      },

      ]
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		//this.data = await this.generalApiGet("questionlists") 
      if(this.$store.state.auth.user.userroles[0].name=="brand")
      {
        this.data = await this.generalApiGet("user_questionlists/"+this.$store.state.auth.user.id) 
      }
      else
      {        
        this.data = await this.generalApiGet("questionlists") 
      }
      console.log(this.data);
      await this.$store.dispatch('questionlists/setQuestionlists',this.data)
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>